export default __webpack_public_path__ + "static/media/component-177-2.d2c6c078.png";